import { ArrowLeft } from 'lucide-react'
import { Helmet } from 'react-helmet'
import { Link, useParams } from 'react-router'

import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { useSequence } from '@/models/sequence'
import { SEQUENCES_PATH } from './sequenceStatus'
import { SequenceSummary } from './SequenceSummary'
import { SequenceTimeline } from './SequenceTimeline'

export function SequenceDetail() {
  const { id = '' } = useParams()
  const { data: sequence, isLoading, isError } = useSequence(id)

  return (
    <>
      <Helmet>
        <title>{sequence?.salesLeadName ? `${sequence.salesLeadName} · Sequence` : 'Sequence'}</title>
      </Helmet>
      <div className="flex flex-col gap-6 p-6">
        <div>
          <Button variant="link" className="px-0" asChild>
            <Link to={SEQUENCES_PATH}>
              <ArrowLeft className="mr-1 size-4" />
              Back to Sequences
            </Link>
          </Button>
        </div>
        {isLoading && <Skeleton className="h-64 w-full" />}
        {isError && <p className="text-muted-foreground text-sm">This sequence couldn’t be loaded.</p>}
        {sequence && (
          <>
            <SequenceSummary sequence={sequence} />
            <Card>
              <CardContent>
                <SequenceTimeline sequence={sequence} />
              </CardContent>
            </Card>
          </>
        )}
      </div>
    </>
  )
}
